import React from 'react'

interface SchemaProps {
  type: string
  headline: string
  url: string
  datePublished?: string
  dateCreated: string
  dateModified?: string
  abstract: string
  author: string
  timeRequired?: string
}

export const Schema: React.FunctionComponent<SchemaProps> = ({
  type,
  headline,
  url,
  datePublished,
  dateCreated,
  dateModified,
  abstract,
  author,
  timeRequired,
}) => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: `
      <script type="application/ld+json">${JSON.stringify({
        '@context': 'https://schema.org',
        '@type': type,
        publisher: {
          '@type': 'Organization',
          name: 'airfocus, GmbH',
          url: 'https://www.airfocus.com/',
          logo: 'https://i.imgur.com/RFXZ7wv.png',
        },
        url,
        headline,
        abstract,
        description: abstract,
        author,
        datePublished,
        dateCreated,
        dateModified,
        timeRequired,
      })}</script>
      `,
      }}
    />
  )
}
